import debounce from 'p-debounce';
import { FETCH_DEVICE, DEVICES_PAGINATED_FETCH_SUCCEEDED, DEVICES_LAST_LOCATIONS_FETCH_SUCCEED } from '#action/types';

let devicesPaginatedToUpdate = [];
let devicesLastLocationsToUpdate = [];

const updateDevicesPaginated = debounce(store => {
  const { devicesPaginated: { devices = [], totalCount } = {} } = store.getState();
  store.dispatch({
    type: DEVICES_PAGINATED_FETCH_SUCCEEDED,
    payload: devices.map(d => ({
      ...d,
      ...devicesPaginatedToUpdate.find(du => du.id === d.id) ?? {}
    })),
    totalCount
  });
  devicesPaginatedToUpdate = [];
}, 3000);

const updateDevicesLastLocations = debounce(store => {
  const { devicesLastLocations: { devices = [] } = {} } = store.getState();
  store.dispatch({
    type: DEVICES_LAST_LOCATIONS_FETCH_SUCCEED,
    payload: devices.map(d => ({
      ...d,
      ...devicesLastLocationsToUpdate.find(du => du.id === d.id) ?? {}
    }))
  });
  devicesLastLocationsToUpdate = [];
}, 3000);

export default ({
  getDevice(store, uid) {
    const {
      device = {},
      devicesPaginated: { devices: devicesPaginated = [] } = {},
      devicesLastLocations: { devices: devicesLastLocations = [] } = {}
    } = store.getState();
    return device.uid === uid ||
      devicesPaginated.find(d => d.uid === uid) ||
      devicesLastLocations.find(d => d.uid === uid);
  },
  setDevice(store, data) {
    const {
      device = {},
      devicesPaginated: { devices: devicesPaginated = [] } = {},
      devicesLastLocations: { devices: devicesLastLocations = [] } = {}
    } = store.getState();
    if (device.uid === data.uid) {
      store.dispatch({
        type: FETCH_DEVICE,
        payload: { ...device, ...data }
      });
    }

    {
      const indexToUpdate = [];
      devicesPaginated.forEach((d, i) => {
        if (d.uid === data.uid) {
          indexToUpdate.push(i);
        }
      });

      if (indexToUpdate.length) {
        indexToUpdate.forEach(index => {
        // update devices silently just to keep store in sync with updates
          const d = { ...devicesPaginated[index], ...data };
          devicesPaginatedToUpdate.unshift(d);
        });
        updateDevicesPaginated(store);
      }
    }
    {
      const indexToUpdate = [];
      devicesLastLocations.forEach((d, i) => {
        if (d.uid === data.uid) {
          indexToUpdate.push(i);
        }
      });

      if (indexToUpdate.length) {
        indexToUpdate.forEach(index => {
        // update devices silently just to keep store in sync with updates
          const d = { ...devicesLastLocations[index], ...data };
          devicesLastLocationsToUpdate.unshift(d);
        });
        updateDevicesLastLocations(store);
      }
    }
  }
});
